var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-legend"},_vm._l((_vm.statusOptions),function(status,index){return _c('span',{key:index,staticClass:"status"},[_c('BadgeCircle',{attrs:{"color":status.color}}),_vm._v("\n    "+_vm._s(status.legend)+"\n  ")],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }